export const toDecimal = (x, num) => {
  if (typeof x == "string") return x;
  if (num === 0) return parseInt(x);
  if (num === null || num === undefined) return x;
  let f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  f = Math.round(x * Math.pow(10, num)) / Math.pow(10, num);
  let s = f.toString();
  let rs = s.indexOf(".");
  if (rs < 0) {
    rs = s.length;
    s += ".";
  }
  while (s.length <= rs + num) {
    s += "0";
  }
  return s;
};

export function toFixed(value, unit) {
  if (value == null) return "-";
  if (unit.unit && unit.unit.indexOf("|") > -1) {
    const mm = unit.unit.split(",")[0].match(/\d+:[^#]+/g);
    let vala = mm.find((u) => u.split(":")[0] == value);
    if (vala) {
      return vala ? vala.split(":")[1].replace("#", "").replace("*", "") : "-";
    }
    //状态
    const uu = unit.unit.split(",")[1].split("|");
    let value2 = value;
    let val = [];
    uu.forEach((u, i) => {
      let l = Math.pow(2, uu.length - 1 - i);
      if (value2 >= l) {
        value2 = value2 - l;
        if (u) {
          val.push(u);
        }
      }
    });
    return val.join(",");
  } else if (unit.unit && unit.unit.indexOf("#") > -1) {
    const uu = unit.unit.match(/\d+:[^#]+/g);
    const val = uu.find((u) => u.indexOf(value) > -1);
    return val ? val.split(":")[1].replace("#", "").replace("*", "") : "-";
  }
  return unit ? toDecimal(value, unit.precision) : value;
}

export function getUnit(unit) {
  if (unit) {
    if (unit.unit && unit.unit.indexOf("#") > -1) {
      return "";
    } else {
      return unit.unit ? ` ${unit.unit}` : "";
    }
  } else {
    return "";
  }
}
